import Hidden from "@material-ui/core/Hidden"
import { HamburgerButtonMinimize, HamburgerButtonOpen } from "navigation-ui/HamburgerButtonMinimize"
import React  from "react"
import { ReactFC } from "types"


export const ToggleMenuButton: ReactFC = () => {
    return (
        <>
            <Hidden xsDown implementation="css">
                <HamburgerButtonMinimize />
            </Hidden>
            <Hidden smUp implementation="css">
                <HamburgerButtonOpen />
            </Hidden>
        </>
    )
}

export default ToggleMenuButton